import { useEffect } from "react";
import { Modal as ModalPrism } from "@ww-digital/prism";
import styles from "./styles.module.scss";
import { dispatchEvent } from "utils/analytics";

interface ModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
  title: string;
  description: string;
  close: string;
}

const Modal = ({ isOpen, onOpenChange, title, description, close }: ModalProps): JSX.Element => {
  useEffect(() => {
    if (isOpen) {
      dispatchEvent({
        event: "non_click_event",
        event_key: "quiz:modal_opened",
        event_category: "quiz",
        event_action: "modal_opened"
      });
    }
  }, [isOpen]);

  return (
    <ModalPrism
      trigger={null}
      isOpen={isOpen}
      content={{ className: styles.dialogContent }}
      title={{
        dialogTitle: title,
        className: styles.dialogTitle
      }}
      description={{
        // @ts-expect-error untyped
        dialogDescription: (<div className={styles.dialogDescription}>{description}</div>),
        asChild: true,
      }}
      close={{
        dialogCTA: close,
        className: styles.dialogClose,
        attributes: {
          "da-category": "quiz",
          "da-action": "modal_close",
          "da-label": close,
        }
      }}
      overlay={{
        className: styles.dialogOverlayRebrand
      }}
      preset={"assessment"}
      onOpenChange={onOpenChange}
    />
  );
};

export default Modal;
